<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path d="M10 3.5L4.5 9L2 6.5" stroke="#1ED1AC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>